import {
    GET_CUSTOMER_PAYMENT_DATA_REQUEST,
    GET_CUSTOMER_PAYMENT_DATA_SUCCESS,
    GET_CUSTOMER_PAYMENT_DATA_ERROR,
    GET_CUSTOMER_PAYMENT_DATE_WISE_REQUEST,
    GET_CUSTOMER_PAYMENT_DATE_WISE_SUCCESS,
    GET_CUSTOMER_PAYMENT_DATE_WISE_ERROR,
    GET_CUSTOMER_AGING_REPORT_REQUEST,
    GET_CUSTOMER_AGING_REPORT_SUCCESS,
    GET_CUSTOMER_AGING_REPORT_ERROR
} from "../actions/types";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

const axios = require("axios");
export const getCustomerPaymentReport = (token, data) => (dispatch) => {

    dispatch({ type: GET_CUSTOMER_PAYMENT_DATA_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/funcGetCustomerPaymentLedgerReport`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {


            from_date: moment(data.from_date).format("MM-DD-YYYY"),
            to_date: moment(data.to_date).format("MM-DD-YYYY"),
            customer_id: data.customer_id,
            status: data.status === "All" ? null : data.status,
        }
    })
        .then((response) => {
            return dispatch({ type: GET_CUSTOMER_PAYMENT_DATA_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_CUSTOMER_PAYMENT_DATA_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_CUSTOMER_PAYMENT_DATA_ERROR,
                payload: error.response,
            });
        });
};

export const getCustomerPaymentReportDateWise = (token, data) => (dispatch) => {

    dispatch({ type: GET_CUSTOMER_PAYMENT_DATE_WISE_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/funcGetCustomerPaymentLedgerDateWiseReport`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {
            from_date: moment(data.from_date).format("MM-DD-YYYY"),
            to_date: moment(data.to_date).format("MM-DD-YYYY"),
            customer_id: data.customer_id,
            status: data.status === "All" ? null : data.status,
        }
    })
        .then((response) => {
            return dispatch({ type: GET_CUSTOMER_PAYMENT_DATE_WISE_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_CUSTOMER_PAYMENT_DATE_WISE_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_CUSTOMER_PAYMENT_DATE_WISE_ERROR,
                payload: error.response,
            });
        });
};


export const getCustomerAgingReport = (token, data) => (dispatch) => {

    dispatch({ type: GET_CUSTOMER_AGING_REPORT_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/CustomerAggingDetailReport`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {
            to_date: moment(data.to_date).format("MM-DD-YYYY"),
            gender_id: (data.gender === "All" || data.gender === undefined) ? null : data.gender,
            term_id: (data.terms === "All" || data.terms === undefined) ? null : data.terms,
            payment_class_id: (data.paymentClass === "All" || data.paymentClass === undefined) ? null : data.paymentClass,
        }
    })
        .then((response) => {
            return dispatch({ type: GET_CUSTOMER_AGING_REPORT_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_CUSTOMER_AGING_REPORT_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_CUSTOMER_AGING_REPORT_ERROR,
                payload: error.response,
            });
        });
};




